import { InfrastructureProviderEnum } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/infrastructureEventModal/InfrastructureProvider";
import { describedTypeSchema } from "features/CenterContent/shared/operationalInformation/utils";
import { z } from "zod";

export const reasonErrorMessage =
  "Du må velge årsak for å kunne opprette hendelsen";

export const baseSchema = z.object({
  stretchName: z
    .string()
    .min(1, "Du må fylle ut et strekningsnavn for å kunne opprette hendelsen"),
  reason: describedTypeSchema.nullable().refine((val) => !val || val.type, {
    message: reasonErrorMessage,
    path: ["type"], // Ensure the error is assigned to the 'type' field
  }),
  action: describedTypeSchema.nullable(),
  consequence: describedTypeSchema.nullable(),
  infrastructureProvider: z.nativeEnum(InfrastructureProviderEnum).nullable(),
});
